import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';

import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { UtilsService } from 'src/app/core/services/utils.service';

@Injectable({
  providedIn: 'root'
})
export class BoatInscriptionService extends BaseProvider {

  dataSource: any[] = [];
  ticketDataSource: any[] = [];
  fineList: any[] = [];  
  ssn: any;
  constructor(
    public globals: GlobalsService,
    public http: HttpClient,
    public utils: UtilsService,
  ) {
    super();
   
    this.baseUrl = 'maritime';
  }
  
  getBoat(params) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + '/id/' + params.ssn + '/register/' + params.regNum;
      
      // 'https://ws.drna.pr.gov/xuvoapi/serv/getshipown/' + 
      //            '?id=' + params.ssn + 
      //            '&registro=' + params.regNum  + 
      //            '&NEPTUNO_ACC_KEY=12345';      
      
      this.http.get<any>(this.url).subscribe(
        (data: any) => {
          console.log(data);
          resolve(data);
        },
        (err) => {
          console.log(err);
          this.dataSource = [];          
          reject(err);
        }
      );
    });
  }

  getFines(params){
    return new Promise((resolve, reject) => {
      this.url =  this.url = this.globals.dataUrl + this.baseUrl + '/register/' + params.regNum + '/process/' + params.userProcessId;
      
        // 'https://ws.drna.pr.gov/xuvoapi/serv/gettickets/' + 
        // '?&registro=' + params.regNum  + 
        // '&NEPTUNO_ACC_KEY=12345';      
      
      this.http.get<any>(this.url).subscribe(
        (data: any) => {
          console.log(data);
          resolve(data);
        },
        (err) => {
          this.ticketDataSource = [];
          reject(err);
        }
      );
    });
  }

  getUserProcessFineAssociation(userProcessId){
    return new Promise((resolve, reject) => {
      this.url =  this.url = this.globals.dataUrl + this.baseUrl + '/process/' + userProcessId;
            
      this.http.get<any>(this.url).subscribe(
        (data: any) => {
          console.log(data);
          resolve(data);
        },
        (err) => {
          
          reject(err);
        }
      );
    });
  }

  saveBoats(data){
    return new Promise( (resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl;

      this.http
      .post(this.url, data)
      .subscribe(
          (data:any) => {
            resolve(data)
           },
          (err:any) => {
            reject(err)
           }
      );
    });    
  }

  getFinesPayed(processId: any){
    return new Promise((resolve, reject) => {
      this.url = `${this.globals.dataUrl}${this.baseUrl}/finesPayed/process/${processId}`;

      this.http.get(this.url)
      .subscribe(
        (data: any) => {
          resolve(data)
        },
        (err: any) => {
          reject(err)
        }
      );
    });
  }


}


